import { PlusOutlined } from '@ant-design/icons';
import { Col, Row, Table, Tag } from "antd";
import { ContentHeader } from "../../components";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { layDanhSachChamCong } from "../../services/chamcong";
import { toast } from "react-toastify";
import { Links } from "../../helpers/Links";
import { Link } from "react-router-dom";
import { menuHelper } from "../../helpers/account";
import { trangThaiChamCong } from '../../constants';

const QuanTriChamCongThang = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [dataTable, setDataTable] = useState<any>();
    const menu: any = menuHelper.checkMultiPermission([Links.ChamCong.ThemChamCong, Links.ChamCong.ChiTietChamCongThang]);

    const loadDanhSachChamCong = async () => {
        setIsLoading(true);
        try {
            var data = await layDanhSachChamCong();
            setDataTable((data || []).map((v: any) => { return { ...v, key: v.idChamCong } }));
        } catch (ex: any) {
            toast.error(ex);
        }

        setIsLoading(false);
    };

    useEffect(() => {
        loadDanhSachChamCong();
    }, [])

    return (
        <section>
            <ContentHeader title="Chấm công tháng" />
            <Row className="mb-2">
                <Col span="24">
                    {
                        menu[Links.ChamCong.ThemChamCong] &&
                        <Link className="hrm-btn float-right hrm-btn-warning" to={Links.ChamCong.ChiTietChamCongThang}><PlusOutlined rev="" />Thêm mới</Link>
                    }
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={dataTable}
                            loading={isLoading}
                            locale={{ emptyText: "Không có dữ liệu" }}
                        >
                            <Column title="Tháng" dataIndex="thangNam" key="thangNam" />
                            <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                            <Column title="Người chấm công" dataIndex="nguoiChamCong" key="nguoiChamCong" />
                            <Column title="Trạng thái" dataIndex="trangThai" key="trangThai" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case trangThaiChamCong.khoiTao: tag = (<Tag color="processing">Khởi tạo</Tag>); break;
                                    case trangThaiChamCong.thuHoi: tag = (<Tag color="warning">Thu hồi</Tag>); break;
                                    case trangThaiChamCong.trinhLDPhong: tag = (<Tag color="purple">Trình lãnh đạo phòng</Tag>); break;
                                    case trangThaiChamCong.lDPhongTraLai: tag = (<Tag color="error">Lãnh đạo phòng từ chối</Tag>); break;
                                    case trangThaiChamCong.trinhLDPhuTrach: tag = (<Tag color="cyan">Trình lãnh đạo phụ trách</Tag>); break;
                                    case trangThaiChamCong.lDPhuTrachTraLai: tag = (<Tag color="error">Lãnh đạo phụ trách từ chối</Tag>); break;
                                    case trangThaiChamCong.lDPhuTrachDuyet: tag = (<Tag color="success">Thành công</Tag>); break;
                                }
                                return tag;
                            }} />
                            {
                                menu[Links.ChamCong.ChiTietChamCongThang] &&
                                <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                    return <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.ChamCong.ChiTietChamCongThang + "?id=" + record.idChamCong}>Xem</Link>
                                }} />
                            }
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default QuanTriChamCongThang;